import { combineReducers } from "redux";

import * as animation from "./animation";
import * as config from "./config";
import * as data from "./data";
import * as exchange from "./exchange";
import * as loyalty from "./loyalty";
import * as memberTier from "./memberTier";
import * as merchant from "./merchant";
import * as referral from "./referral";
import * as requestStatus from "./requestStatus";
import * as reward from "./reward";
import * as share from "./share";
import * as shareCount from "./shareCount";
import * as widget from "./widget";

export const rootReducer = combineReducers({
  animation: animation.reducer,
  config: config.reducer,
  data: data.reducer,
  exchange: exchange.reducer,
  loyalty: loyalty.reducer,
  memberTier: memberTier.reducer,
  merchant: merchant.reducer,
  referral: referral.reducer,
  requestStatus: requestStatus.reducer,
  reward: reward.reducer,
  share: share.reducer,
  shareCount: shareCount.reducer,
  widget: widget.reducer,
});

interface PersistState {
  rehydrated: boolean;
  version: number;
}

export interface StoreState {
  animation: animation.StoreState;
  config: config.StoreState;
  data: data.StoreState;
  exchange: exchange.StoreState;
  loyalty: loyalty.StoreState;
  memberTier: memberTier.StoreState;
  merchant: merchant.StoreState;
  referral: referral.StoreState;
  requestStatus: requestStatus.StoreState;
  reward: reward.StoreState;
  share: share.StoreState;
  shareCount: shareCount.StoreState;
  widget: widget.StoreState;
  _persist: PersistState;
}
